module.exports = __webpack_public_path__ + "static/img/jingyin2.48bdb76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/jingyin2.png
// module id = Yhek
// module chunks = 24